import SelectList from './Default/SelectList';

export default function TaxStatusSelect({ value, setValue, inputClass }) {
    const taxStatusOptions = [
        { label: 'ИП' },
        { label: 'Физическое лицо' },
        { label: 'Самозанятый' }
    ];
    
    const optionsWithLabelAsValue = taxStatusOptions.map(opt => ({
        value: opt.label,
        label: opt.label
    }));

    return (
        <div className={inputClass}>
            <SelectList
                options={optionsWithLabelAsValue}
                value={value}
                setValue={setValue}
                className={inputClass}
                defaultText="Выберите..."
            />
        </div>
    );
}